import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import Link from 'flarum/common/components/Link';
import Button from 'flarum/common/components/Button';
import ParseAthleticMatchesModal from './ParseAthleticMatchesModal';
export default class TaldezainaPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "canManage", false);
    _defineProperty(this, "refreshingStandings", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.canManage = !!(app.forum.attribute('canManagePlayers') || app.session.user && (app.session.user.attribute('canManagePlayers') || app.session.user.isAdmin()));
    if (!this.canManage) {
      m.route.set('/');
      return;
    }
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/taldezaina/tasks'
    }).then(res => {
      if (res && res.meta && typeof res.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = res.meta.pendingCount;
        m.redraw();
      }
    }).catch(() => {});
  }
  refreshLeagueStandings() {
    this.refreshingStandings = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/league-standings/refresh'
    }).then(res => {
      if (res && res.success) {
        app.alerts.show({
          type: 'success'
        }, res.message || 'Clasificación actualizada correctamente.');
      } else {
        app.alerts.show({
          type: 'error'
        }, 'No se pudo actualizar la clasificación.');
      }
    }).catch(err => {
      console.error(err);
      app.alerts.show({
        type: 'error'
      }, err && err.response && err.response.error || 'Error al conectar con el servidor.');
    }).finally(() => {
      this.refreshingStandings = false;
      m.redraw();
    });
  }
  view() {
    if (!this.canManage) return null;
    return m("div", {
      className: "TaldezainaPage"
    }, m("div", {
      className: "container",
      style: "padding-top: 40px; padding-bottom: 40px;"
    }, m("div", {
      className: "Taldezaina-navigation",
      style: "display: flex; justify-content: space-between; align-items: center; margin-bottom: 40px;"
    }, m(Link, {
      href: "/",
      className: "Button Button--secondary",
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; border: 1px solid rgba(255, 255, 255, 0.15); background: rgba(255, 255, 255, 0.05); transition: background 0.2s ease, border-color 0.2s ease;"
    }, m("i", {
      className: "fas fa-home"
    }), app.translator.trans('bizkaitarra-lineup.forum.taldezaina.nav_back_home')), app.session.user && (app.session.user.isAdmin() || app.session.user.attribute('canManagePlayers')) && m("div", {
      style: "display: flex; gap: 10px; flex-wrap: wrap;"
    }, m(Button, {
      className: "Button Button--secondary",
      loading: this.refreshingStandings,
      onclick: () => this.refreshLeagueStandings(),
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; transition: background 0.2s ease; border: 1px solid rgba(255, 255, 255, 0.2);"
    }, m("i", {
      className: "fas fa-sync-alt"
    }), "Actualizar Clasificaci\xF3n Liga"), app.session.user.isAdmin() && m(Button, {
      className: "Button Button--primary",
      onclick: () => app.modal.show(ParseAthleticMatchesModal),
      style: "display: inline-flex; align-items: center; gap: 8px; font-weight: bold; border-radius: 8px; padding: 10px 16px; transition: background 0.2s ease;"
    }, m("i", {
      className: "fas fa-file-import"
    }), "Importar partidos Athletic"))), m("div", {
      className: "Taldezaina-header",
      style: "margin-bottom: 40px; text-align: left;"
    }, m("h2", {
      style: "font-size: 2.5em; font-weight: 800; color: var(--heading-color); margin: 0; letter-spacing: -0.02em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.taldezaina.title')), m("p", {
      style: "color: var(--muted-color); font-size: 1.25em; margin-top: 8px; max-width: 600px; line-height: 1.5;"
    }, app.translator.trans('bizkaitarra-lineup.forum.taldezaina.description'))), m("div", {
      className: "Taldezaina-grid",
      style: "display: grid; grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); gap: 30px; max-width: 900px; margin-top: 20px;"
    }, m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.tasks'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none; position: relative;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1; position: relative;"
    }, "\uD83D\uDCCB", Number(app.forum.attribute('pendingTaldezainaTasksCount')) > 0 && m("span", {
      style: "position: absolute; top: -5px; right: -15px; background: #e53935; color: #fff; font-size: 0.35em; font-weight: bold; border-radius: 12px; padding: 4px 10px; box-shadow: 0 4px 10px rgba(229,57,53,0.5);"
    }, app.forum.attribute('pendingTaldezainaTasksCount'))), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Tareas"), m("span", {
      style: "font-size: 0.9em; color: var(--muted-color); margin-top: 6px; font-weight: 600;"
    }, Number(app.forum.attribute('pendingTaldezainaTasksCount')) > 0 ? "".concat(app.forum.attribute('pendingTaldezainaTasksCount'), " pendientes") : 'Al día ✓')), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.players'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83C\uDFC3\u200D\u2642\uFE0F"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.taldezaina.card_players'))), m(Link, {
      href: app.route('bizkaitarra-lineup.matches'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83C\uDFDF\uFE0F"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.taldezaina.card_matches'))), m(Link, {
      href: app.route('bizkaitarra-lineup.rivals'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83D\uDEE1\uFE0F"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, app.translator.trans('bizkaitarra-lineup.forum.taldezaina.card_rivals'))), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.competitions'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83C\uDFC6"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Competiciones"), m("span", {
      style: "font-size: 0.9em; color: var(--muted-color); margin-top: 6px; font-weight: 600;"
    }, "Reglas & Juegos")), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.gorbea'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\u26F0\uFE0F"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Pastor del Gorbea")), m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.mundial'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83C\uDFC6"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Mundial 2026")), app.session.user && app.session.user.isAdmin() && m(Link, {
      href: app.route('bizkaitarra-lineup.taldezaina.notifications'),
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83D\uDD14"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Notificaciones")), m(Link, {
      href: "/taldezaina/preguntas-seguridad",
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, "\uD83D\uDEE1\uFE0F"), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Preguntas Seguridad")), app.session.user && app.session.user.isAdmin() && m("a", {
      href: app.forum.attribute('apiUrl') + '/custom-emojis-pack',
      download: true,
      className: "TaldezainaCard",
      style: "display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 50px 30px; border-radius: 20px; background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); cursor: pointer; transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275), border-color 0.3s ease, box-shadow 0.3s ease; text-decoration: none;",
      oncreate: vnode => {
        const el = vnode.dom;
        el.addEventListener('mouseenter', () => {
          el.style.transform = 'translateY(-10px) scale(1.03)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.3)';
          el.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.3)';
        });
        el.addEventListener('mouseleave', () => {
          el.style.transform = 'translateY(0) scale(1)';
          el.style.borderColor = 'rgba(255, 255, 255, 0.1)';
          el.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.15)';
        });
      }
    }, m("div", {
      style: "font-size: 6rem; margin-bottom: 25px; filter: drop-shadow(0 6px 12px rgba(0,0,0,0.2)); line-height: 1;"
    }, m("i", {
      className: "fab fa-whatsapp",
      style: "color: #25D366;"
    })), m("span", {
      style: "font-size: 1.6em; font-weight: 800; color: var(--heading-color); letter-spacing: -0.01em;"
    }, "Stickers WhatsApp"), m("span", {
      style: "font-size: 0.9em; color: var(--muted-color); margin-top: 6px; font-weight: 600;"
    }, "Descargar .wastickers")))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/TaldezainaPage', TaldezainaPage);